import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';
import { Pagination, PaginationItem, PaginationProps } from '@mui/material';

const Primary = (props: Omit<PaginationProps, 'color' | 'shape'>) => (
    <Pagination
        boundaryCount={0}
        classes={{
            ul: 'justify-center',
        }}
        renderItem={(item) => (
            <PaginationItem
                slots={{ next: ArrowForwardIosIcon, previous: ArrowBackIosNewIcon }}
                {...item}
                className={item.type === 'page' ? 'black-border shadow' : ''}
            />
        )}
        {...props}
        shape="rounded"
        color="primary"
    />
);

const PaginationNamespace = Object.assign(Primary, {
    Primary,
});

export { PaginationNamespace as Pagination };
